angular.module('CaresApp').filter('absolute', [
  '$filter',
  function($filter) {
    return function(num) {
      return $filter('number')(Math.abs(num));
    };
  },
]);
